module.exports = __webpack_public_path__ + "static/produkty_bon_aroma-a7fc6eaf4d5d38fa7573341f6192a02e.png";